import _ from 'lodash'
import { UUID } from '../../plugins/common'

export default class Relation {
  id
  primaryTable
  primaryKey
  foreignTable
  foreignKey
  relationType

  constructor (args) {
    this.id = UUID.create()
    _.assign(this, args)
  }

  static load (args) {
    const relation = new Relation()
    relation.id = args.id
    relation.primaryTable = args.primaryTable
    relation.primaryKey = args.primaryKey
    relation.foreignTable = args.foreignTable
    relation.foreignKey = args.foreignKey
    return relation
  }

  equalsTo (ref) {
    return this.primaryTable === ref.primaryTable &&
      this.primaryKey === ref.primaryKey &&
      this.foreignTable === ref.foreignTable &&
      this.foreignKey === ref.foreignKey &&
      this.relationType === ref.relationType
  }
}



// WEBPACK FOOTER //
// ./src/store/form/relation.js